import { render, staticRenderFns } from "./OauthProviderForm.vue?vue&type=template&id=8221ade6"
import script from "./OauthProviderForm.vue?vue&type=script&lang=js"
export * from "./OauthProviderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports